import { OutlinedInput } from "@material-ui/core";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';

/**
 * Render checkbox + field(s) ของ retrieve-source เดียว (API/Azure/Google/Facebook)
 * ตาม config จาก buildRetrieveUrlSources — ดู retrieveUrlSources.js สำหรับรายละเอียด
 * ความไม่สม่ำเสมอที่คงไว้ตามของเดิมโดยตั้งใจ
 */
const RetrieveSourceField = ({ source, retrieve, setRetrieve, primaryColor }) => {
    const { key, label, fields, staticFields } = source;
    const isChecked = Array.isArray(retrieve) && retrieve.some((obj) => obj.from === key);
    const activeEntry = Array.isArray(retrieve) && retrieve.find((obj) => obj.from === key);

    const handleToggle = (e) => {
        if (e.target.checked) {
            const fieldValues = fields.reduce(
                (acc, field) => ({
                    ...acc,
                    [field.name]:
                        field.initialValueOnEnable !== undefined ? field.initialValueOnEnable : field.value,
                }),
                {}
            );
            setRetrieve([...retrieve, { from: key, ...fieldValues, ...(staticFields || {}) }]);
        } else {
            setRetrieve(retrieve.filter((obj) => obj.from !== key));
            fields.forEach((field) => field.onValueChange(field.type === 'checkbox' ? false : ''));
        }
    };

    const handleTextFieldChange = (field) => (e) => {
        const cleaned = e.target.value.startsWith(' ') ? '' : e.target.value;
        field.onValueChange(cleaned);
        setRetrieve(
            retrieve.map((item) => (item.from === key ? { ...item, [field.name]: e.target.value } : item))
        );
    };

    const handleCheckboxFieldChange = (field) => (e) => {
        const checked = e.target.checked;
        field.onValueChange(checked);

        // ติ๊กออก -> เคลียร์ field ที่ผูกไว้ด้วย (เช่น clientKey/secretKey ตอนเลิกใช้ Client Secret)
        const clearedUpdates = {};
        if (!checked && Array.isArray(field.clearFieldsOnUncheck)) {
            field.clearFieldsOnUncheck.forEach((name) => {
                const relatedField = fields.find((f) => f.name === name);
                if (relatedField) relatedField.onValueChange('');
                clearedUpdates[name] = '';
            });
        }

        setRetrieve(
            retrieve.map((item) =>
                item.from === key ? { ...item, [field.name]: checked, ...clearedUpdates } : item
            )
        );
    };

    return (
        <>
            <FormControlLabel
                onChange={handleToggle}
                control={<Checkbox style={{ color: primaryColor }} checked={isChecked} />}
                label={label}
            />
            {activeEntry &&
                fields
                    .filter((field) => !field.hidden || !field.hidden(activeEntry))
                    .map((field) => {
                        if (field.type === 'checkbox') {
                            return (
                                <div key={field.name} style={field.wrapperStyle}>
                                    <FormControlLabel
                                        onChange={handleCheckboxFieldChange(field)}
                                        control={
                                            <Checkbox
                                                style={{ color: primaryColor }}
                                                checked={!!activeEntry[field.name]}
                                            />
                                        }
                                        label={field.label}
                                    />
                                </div>
                            );
                        }

                        const isRequired = field.required ? field.required(activeEntry) : true;

                        return (
                            <div key={field.name} style={field.wrapperStyle}>
                                <div>{field.label}</div>
                                <OutlinedInput
                                    type={field.inputType}
                                    value={field.value}
                                    style={{
                                        width: '60%',
                                        maxWidth: '360px',
                                        height: '36px',
                                        borderRadius: '6px',
                                        marginTop: '15px',
                                        ...field.extraInputStyle,
                                    }}
                                    onChange={handleTextFieldChange(field)}
                                    placeholder={field.placeholder}
                                />
                                {isRequired &&
                                    (field.value === '' ? (
                                        <Alert severity="error" style={{ marginTop: field.alertMarginTop }}>
                                            {field.errorText}
                                        </Alert>
                                    ) : (
                                        <Alert severity="success" style={{ marginTop: field.alertMarginTop }}>
                                            {field.errorText}
                                        </Alert>
                                    ))}
                            </div>
                        );
                    })}
        </>
    );
};

export default RetrieveSourceField;